var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import useEmotionStyledComponent from '../../hooks/useEmoticonStyledComponent';
var ProgressBar = function (props) {
    var StyledSlimProgress = useEmotionStyledComponent(function () { return ({
        root: {
            height: '8px',
        },
    }); }, LinearProgress);
    return React.createElement(StyledSlimProgress, __assign({}, props, { variant: "determinate" }));
};
export default ProgressBar;
